import React, { Component } from 'react';
import {Storage} from 'aws-amplify';
import fetch from 'node-fetch';

class AwsCostExplorer extends Component {

  state = {
    costs: {}
  };

  componentDidMount() {

    console.log('storage');

    Storage.get('awsCostReports/112018Lite.json')
    .then(res => {
      return fetch(res);
    })
    .then(res => {
      console.log('fetching json...');
      return res.json();
    })
    .then(res => {
      this.setState({costs: res});
      console.log(res);
    })
    .catch(err => {
      console.log(err);
    });

  };

  render() {

    const {costs} = this.state;

    return (
      <div className="AwsCostExplorerPage">
        {Object.keys(costs).map(account => {
          console.log(costs[account].TOTAL);
          return <div key={JSON.stringify(account)}>{`${account}\n$${Math.round(costs[account].TOTAL * 100) / 100}`}</div>;
        })}
      </div>
    );

  };

};

export default AwsCostExplorer;


// WEBPACK FOOTER //
// ./src/components/content/awsCostExplorer/awsCostExplorer.js